<template>
  <div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Config } from '@/configs/config';

export default defineComponent({
  name: 'PaymentPage',
  mounted() {
    const address = this.$route.query.address;
    const userId = this.$route.query.userId;
    const paymentLink = `${Config.STRIPE_PAYMENT_LINK}?prefilled_email=${encodeURIComponent(address)}&client_reference_id=${userId}`;
    window.location.href = paymentLink;
  }
});
</script>

<style scoped>
</style>
